import { useMutation } from "@tanstack/react-query";
import { deleteBulletin } from "../api/deleteBulletin";
import { invalidateBulletinListQuery } from "../queries/useBulletinListQuery";

export const useDeleteBulletinMutation = (callback: () => void) => {
  return useMutation({
    mutationFn: async (bulletinId: string) => {
      return await deleteBulletin(bulletinId);
    },
    onSuccess: () => {
      invalidateBulletinListQuery();
      callback();
    },
    onError: (e) => {
      console.error("Error occurred when deleting bulletin", e);
    },
  });
};
